import script from "./byProperty.vue?vue&type=script&lang=ts&setup=true"
export * from "./byProperty.vue?vue&type=script&lang=ts&setup=true"

import "./byProperty.vue?vue&type=style&index=0&id=2d138322&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d138322"]])

export default __exports__